import axios from 'axios';

const STAGING_URL = 'http://3.109.244.146:3001';
const PROD_URL = process.env.REACT_APP_BASE_URL || 'https://data.dayro.com';

export const getBaseURL = () => {
    const server = localStorage.getItem('dayro_server');
    return server === 'staging' ? STAGING_URL : PROD_URL;
};

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use(
    (config) => {
        config.baseURL = getBaseURL();
        const token = localStorage.getItem("Authorization");
        config.headers.Authorization = token ? `Bearer ${token}` : "";
        return config;
    },
);

axiosInstance.interceptors.response.use(
    (response) => {
        return Promise.resolve(response);
    },
    (error) => {
        if (error !== null && error?.response?.status === 401) {
            localStorage.removeItem("userInfo");
            localStorage.removeItem("selectedPremiseID");
            localStorage.removeItem("selectedUserID");
            localStorage.removeItem("selectedUserEmail");
            localStorage.removeItem("Authorization");
            localStorage.removeItem("permissions");
            window.location.reload();
        }

        return Promise.reject((error) || 'Something went wrong!');
    }
);

export default axiosInstance;
